import { Grid } from '@mui/material';
import Button from 'components/Button';

type HoldingClassActionsProps = {
  isFirst: boolean;
  isLast: boolean;
  hasMoreOptions: boolean;
  onAddHoldingClass: () => void;
  onRemoveHoldingClass: () => void;
};

const HoldingClassActions: React.FC<HoldingClassActionsProps> = ({
  isFirst,
  isLast,
  hasMoreOptions,
  onAddHoldingClass,
  onRemoveHoldingClass,
}: HoldingClassActionsProps) => (
  <Grid container>
    <Grid size={{ xs: 6 }} display="flex" justifyContent="flex-start">
      {isLast && hasMoreOptions && (
        <Button variant="text" onClick={onAddHoldingClass} color="primary">
          Add additional holding class to deal
        </Button>
      )}
    </Grid>
    <Grid size={{ xs: 6 }} display="flex" justifyContent="flex-end">
      {!isFirst && (
        <Button variant="text" onClick={onRemoveHoldingClass} color="error">
          Remove additional holding class
        </Button>
      )}
    </Grid>
  </Grid>
);

export default HoldingClassActions;
